/**
 * Authentication error utilities
 * Centralized functions for checking auth error types
 */

/**
 * Check if an error is a user-cancelled authentication error
 * These errors should be handled silently (user action, not a real error)
 * @param error - The error object to check
 * @returns true if the error is a user-cancelled action
 */
export const isCancelledAuthError = (error: any): boolean => {
  if (!error) return false;
  
  const errorCode = error?.code || '';
  const errorMessage = String(error?.message || '').toLowerCase();
  
  // Check for cancellation error codes
  const cancelledCodes = [
    'auth/popup-closed-by-user',
    'auth/cancelled-popup-request',
    'auth/redirect-cancelled-by-user',
    'auth/popup-blocked'
  ];
  
  if (cancelledCodes.includes(errorCode)) {
    return true;
  }
  
  // Check for cancellation keywords in message
  if (errorMessage.includes('popup') && 
      (errorMessage.includes('closed') || errorMessage.includes('cancelled') || errorMessage.includes('blocked'))) {
    return true;
  }
  
  return false;
};

/**
 * Check if an error is a popup-blocked error
 * @param error - The error object to check
 * @returns true if the error indicates popup was blocked
 */
export const isPopupBlockedError = (error: any): boolean => {
  if (!error) return false;
  
  const errorCode = error?.code || '';
  const errorMessage = String(error?.message || '').toLowerCase();
  
  return errorCode === 'auth/popup-blocked' || 
         (errorMessage.includes('popup') && errorMessage.includes('blocked'));
};

